import request from "api/request";
import {sortBy} from 'lodash';
import moment from "moment";


const parseEvents = events => sortBy(events, event => event.scheduledTime);

export const fetchEvents = (mentorshipId, auth) => request({
  url: `api/v1/mentorships/${mentorshipId}/calendar-events/`,
  method: 'GET',
  auth,
  parse: parseEvents,
});

export const fetchCalendarIntegrations = (auth) => request({
  url: `api/v2/mentorships/available-calendar-integrations/`,
  method: 'GET',
  auth,
});

export const storeCalendarIntegration = (payload, auth) =>
  request({
    url: `api/v2/mentorships/calendar-integration/`,
    method: 'POST',
    auth,
    data: payload,
  });

export const removeCalendarIntegration = (payload, auth) =>
  request({
    url: `api/v2/mentorships/unlink-calendar/`,
    method: 'POST',
    auth,
    data: payload,
  });

export const saveEvent = (mentorship, mentorshipGroupId, event, auth) => {
  const payload = {
    id: event.id,
    title: event.title,
    description: event.description,
    event_frequency: event.event_frequency || event.eventFrequency,
    scheduled_time: moment(event.scheduled_time || event.scheduledTime).toISOString(true),
    session_name: event.session_name || event.sessionName,
    is_pair_group_call: event.is_pair_group_call ?? event.isPairGroupCall,
    is_recurring_event: event.is_recurring_event ?? event.isRecurringEvent,
    repeat_end_date: event.repeat_end_date || event.eventRepeatEndDate,
    mentorship,
    mentor_group: mentorshipGroupId,
    apply_to_recurring: event.apply_to_recurring,
    created_by: event.created_by,
  };

  return request({
    url: `api/v1/mentorships/${mentorship}/calendar-events/${event.id ? event.id + '/' : ''}`,
    method: event.id ? "PUT" : "POST",
    data: payload,
    auth,
  });
};

export const deleteEvent = (event, applyToRecurring, auth) => request({
  url: `api/v1/mentorships/${event.mentorship}/calendar-events/${event.id}/`,
  method: 'DELETE',
  auth,
  data: { apply_to_recurring: applyToRecurring },
});
